import axios from "../../../config/axiosConfig";

export const listarUsuarios = (params = {}) => axios.get("/api/trsrastreo/usuarios", { params });
export const listarUsuariosSimple = () => axios.get("/api/trsrastreo/usuarios-simple");
export const listarIconos = () => axios.get("/api/trsrastreo/iconos");
export const crearUsuario = (data) => axios.post("/api/trsrastreo/usuarios", data);
export const editarUsuario = (id, data) => axios.put(`/api/trsrastreo/usuarios/${id}`, data);
export const listarVehiculos = (params = {}) => axios.get("/api/trsrastreo/vehiculos", { params });
export const listarVehiculosSimple = () => axios.get("/api/trsrastreo/vehiculos-simple");
export const crearVehiculo = (data) => axios.post("/api/trsrastreo/vehiculos", data);
export const editarVehiculo = (id, data) => axios.put(`/api/trsrastreo/vehiculos/${id}`, data);
// Sin usuario directo y sin grupo: los unicos que se pueden eliminar (tarda, recorre todo rastreo_bo).
export const listarVehiculosSinUsuarios = () => axios.get("/api/trsrastreo/vehiculos-sin-usuarios");
export const eliminarVehiculo =(id) => axios.delete(`/api/trsrastreo/vehiculos/${id}`);
export const listarGrupos =() => axios.get("/api/trsrastreo/grupos");
export const crearGrupo = (data) => axios.post("/api/trsrastreo/grupos", data);
export const editarGrupo = (id, data) => axios.put(`/api/trsrastreo/grupos/${id}`, data);
// Vinculo directo usuario-vehiculo (sin pasar por una cuadrilla).
export const vincularUsuarioVehiculo = (data) => axios.post("/api/trsrastreo/usuariovehiculo", data);
// id = el id del vinculo usuariovehiculo en si (no el del vehiculo ni el del usuario).
export const desvincularUsuarioVehiculo = (id) => axios.delete(`/api/trsrastreo/usuariovehiculo/${id}`);
